import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { CheckoutLayout } from 'common/components/layout';

import HoldCancelClubMembership from '../holdCancel/HoldCancelClubMembership';

import ClubMembershipInfo from './ClubMembershipInfo';
import Header from './Header';
import ClubPackageInfo from './components/traditional/ClubPackageInfo';
import MobileToggleSummary from './components/traditional/MobileToggleSummary';
import ShipmentSummary from './components/traditional/ShipmentSummary';

const TraditionalShipment = (props) => {
  const { clubMembership } = props;

  const [isSummaryVisibleOnMobile, setIsSummaryVisibleOnMobile] =
    useState(true);

  const toggleMobileSummary = () => {
    setIsSummaryVisibleOnMobile(!isSummaryVisibleOnMobile);
  };

  const settings = useSelector((state) => state.setting);
  const clubMembershipReducer = useSelector((state) => state.clubMembership);
  const clubPackageReducer = useSelector((state) => state.clubPackage);
  const clubMemberShipmentReducer = useSelector(
    (state) => state.clubMemberShipment
  );

  if (!settings.data || !clubMembershipReducer.data) {
    return (
      <CheckoutLayout title="Club Shipment" loading>
        &nbsp;
      </CheckoutLayout>
    );
  }

  if (!clubMembership.activeClubPackageId) {
    return <Redirect to="/profile/club-membership" />;
  }
  const clubPackage =
    clubPackageReducer.data[clubMembership.activeClubPackageId];
  const clubMemberShipment =
    clubMemberShipmentReducer.data[clubMembership.activeClubMemberShipmentId];
  return (
    <CheckoutLayout title="Club Shipment">
      <MobileToggleSummary
        clubPackage={clubPackage}
        onToggleMobile={toggleMobileSummary}
        clubMemberShipment={clubMemberShipment}
      />
      <div className="c7-checkout">
        <ShipmentSummary
          isSummaryVisibleOnMobile={isSummaryVisibleOnMobile}
          clubMemberShipment={clubMemberShipment}
          clubPackage={clubPackage}
        />

        <div className="c7-checkout__main c7-checkout__main--wide">
          <Header clubMembership={clubMembership} />
          <div className="c7-checkout__content">
            <ClubMembershipInfo clubMembership={clubMembership} />
            <br />
            <ClubPackageInfo
              clubMemberShipment={clubMemberShipment}
              clubPackage={clubPackage}
            />
          </div>
          <HoldCancelClubMembership
            clubMembership={clubMembership}
            clubMemberShipment={clubMemberShipment}
          />
        </div>
      </div>
    </CheckoutLayout>
  );
};

export default TraditionalShipment;
